import { Col, Container, Row } from "reactstrap";
import LoginContainer from "../../../../features/login/component";

const LoginSimple = () => {
  return (
    <div className="page-body">
      <Container fluid className="p-0">
        <Row className="m-0">
          <Col xs="12" className="p-0">
            <LoginContainer />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoginSimple;
